/**
 * Centered date chip between messages from different calendar days
 * ("Today" / "Yesterday" / "17 Apr"). Same muted-pill treatment as the
 * runtime SYSTEM rows so the thread reads as a single timeline.
 */
export function DateSeparator({ label }: { label: string }) {
  return (
    // `sticky` pins the chip to the top of the scroll viewport while its day
    // is in view; the next day's chip scrolls up and takes over. `z-10` keeps
    // it above the message bubbles passing underneath.
    <div className="sticky top-2 z-10 flex justify-center py-1">
      <span className="rounded-full bg-wx-bg-elevated px-3 py-1 text-[11px] font-medium text-wx-fg-muted shadow-sm">
        {label}
      </span>
    </div>
  );
}
